import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import arrow from "../../assets/blogs/arrow.webp";
import { BlogType } from "../../types/types";
import { format } from "date-fns";
import { AuthContext } from "../../context/AuthContext";

type BlogProps = {
  blog: BlogType;
};

const Blog = ({ blog }: BlogProps) => {
  const navigate = useNavigate();
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  let url = "https://admin.techqilla.com";

  return (
    <div
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        navigate(`/blog/${blog.slug}`, { replace: true });
      }}
      className={`${
        theme === "dark"
          ? "bg-white text-black hover:shadow-[0_0_40px_#f20b97]"
          : "hover:shadow-[0_0_40px_#8d19da]"
      } flex flex-col cursor-pointer p-3 border border-secondary rounded-[40px]`}
    >
      <div className="mb-6 rounded-[30px] overflow-hidden">
        <img
          src={`${url}${blog.cover.url}`}
          alt=""
          className="w-full h-[200px]"
        />
      </div>
      <div className="flex justify-between mb-4">
        <div className="flex gap-4">
          <img
            src={`${url}${blog.techqilla_authors[0].image.url}`}
            alt={blog.techqilla_authors[0].name}
            className="size-8 rounded-full"
          />
          <p className="sm:text-lg font-gtAmerica font-semibold">
            {blog.techqilla_authors.map((author) => author.name).join(", ")}
          </p>
        </div>
        <p className="sm:text-lg font-gtAmerica font-semibold">
          {format(blog.createdAt, "MMM dd, yyyy")}
        </p>
      </div>
      <div className="flex justify-between text-lg font-semibold font-gtAmerica mb-5 text-center sm:text-left">
        <p>{blog.title}</p>
      </div>
      <p className="opacity-50 font-gtAmerica mb-4 text-center sm:text-left">{blog.description}</p>
      <div className="flex justify-between items-center">
        <div className="flex gap-5">
          {blog.techqilla_categories.map((cat, index) => (
            <div className="card-gradient p-[2px] rounded-full">
              <div
                key={index}
                className={`${
                  theme === "dark" ? "bg-white" : "bg-black"
                } py-2 px-4  rounded-3xl font-gtAmerica font-semibold`}
              >
                {cat.name}
              </div>
            </div>
          ))}
        </div>
        <div className="size-8 flex justify-center items-center bg-secondary rounded-full">
          <img src={arrow} alt="" className="" />
        </div>
      </div>
    </div>
  );
};

export default Blog;
